import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_DEMS_STATE,
});

export const syncDems = () => ({
  type: types.SYNC_DEMS.REQUEST,
});

export const syncDemsSuccess = (dems) => ({
  type: types.SYNC_DEMS.SUCCESS,
  dems,
});

export const syncDemsFailure = (error) => ({
  type: types.SYNC_DEMS.FAILURE,
  error,
});

export const fetchDem = (demId) => ({
  type: types.FETCH_DEM.REQUEST,
  demId,
});

export const fetchDemSuccess = (dem) => ({
  type: types.FETCH_DEM.SUCCESS,
  dem,
});

export const fetchDemFailure = (error) => ({
  type: types.FETCH_DEM.FAILURE,
  error,
});

export const saveDem = (payload) => ({
  type: types.SAVE_DEM.REQUEST,
  payload,
});

export const saveDemSuccess = () => ({
  type: types.SAVE_DEM.SUCCESS,
});

export const saveDemFailure = (error) => ({
  type: types.SAVE_DEM.FAILURE,
  error,
});

export const archiveDem = (demId) => ({
  type: types.ARCHIVE_DEM.REQUEST,
  demId,
});

export const archiveDemSuccess = () => ({
  type: types.ARCHIVE_DEM.SUCCESS,
});

export const archiveDemFailure = (error) => ({
  type: types.ARCHIVE_DEM.FAILURE,
  error,
});

export const resetDemStats = (demId) => ({
  type: types.RESET_DEM_STATS.REQUEST,
  demId,
});

export const resetDemStatsSuccess = () => ({
  type: types.RESET_DEM_STATS.SUCCESS,
});

export const resetDemStatsFailure = (error) => ({
  type: types.RESET_DEM_STATS.FAILURE,
  error,
});

export const generateAiDem = ({ prompt, currentDesign }) => ({
  type: types.GENERATE_AI_DEM.REQUEST,
  prompt,
  currentDesign,
});

export const generateAiDemSuccess = ({ message, design, designSnapshotBefore }) => ({
  type: types.GENERATE_AI_DEM.SUCCESS,
  message,
  design,
  designSnapshotBefore,
});

export const generateAiDemFailure = (error) => ({
  type: types.GENERATE_AI_DEM.FAILURE,
  error,
});

export const toggleAiPanel = () => ({
  type: types.TOGGLE_DEM_AI_PANEL,
});

export const resetAiConversation = () => ({
  type: types.RESET_DEM_AI_CONVERSATION,
});

export const undoLastAiDesign = (messageId) => ({
  type: types.UNDO_LAST_DEM_AI_DESIGN,
  messageId,
});
